import { CaseUpdatePresetModel } from './caseUpdatePresetModel';

export class EditCaseUpdatePresetModel extends CaseUpdatePresetModel {
}
